import React, {useEffect, useState} from 'react';
import {Navigate, useNavigate, useParams} from 'react-router-dom';
import {resolvePresentationSlug} from '../../service/presentation.service';
import SlugResolutionContext from '../../context/SlugResolutionContext';
import PresLoaderWrapper from './PresLoaderWrapper';
import PresentationPage from './PresentationPage';

interface ResolvedSlug {
    presentationId: string;
    params: {[key: string]: string};
}

function SlugWrapper(): JSX.Element {
    const {slug} = useParams<{slug: string}>();
    const navigate = useNavigate();
    const [resolution, setResolution] = useState<ResolvedSlug | null>(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!slug) {
            navigate('/', {replace: true});
            return;
        }

        resolvePresentationSlug(slug).then((result) => {
            if (!result) {
                setFailed(true);
                return;
            }

            const params: {[key: string]: string} = {};
            result.params.forEach(({key, value}) => {
                params[key] = value;
            });

            setResolution({presentationId: result.presentationId, params});
        });
    }, [slug, navigate]);

    if (failed) {
        return <Navigate replace to="/" />;
    }

    if (!resolution) {
        return (
            <div className="c-spinner">
                <div className="c-spinner__main">
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        );
    }

    return (
        <SlugResolutionContext.Provider value={resolution}>
            <PresLoaderWrapper>
                <PresentationPage />
            </PresLoaderWrapper>
        </SlugResolutionContext.Provider>
    );
}

export default SlugWrapper;
